import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalTextPreset } from '~/@types/text-preset'

import { ArrowLeftIcon } from '~/components/Abstracts/Icons'
import { CloseIcon } from '~/components/UI/Icons'

import { useStyle } from '~/providers/StyleProvider'

import { CTA } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface CartPopInHeaderProps {
  className?: string
  title?: string
  close?: () => void
  withDesktopBack?: boolean
  alignTitleLeft?: boolean
  noBorder?: boolean
}

export function CartPopInHeader({
  className,
  title,
  close,
  withDesktopBack,
  alignTitleLeft,
  noBorder = false,
}: CartPopInHeaderProps) {
  const t = useTranslate()
  const variantTitleTextStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Primary,
  })

  return (
    <div
      className={cx(css.CartPopInHeader, className, {
        withDesktopBack,
        noBorder,
      })}>
      <div className={cx(css.cartTitle, variantTitleTextStyle)}>
        {!alignTitleLeft && <div className={cx(css.fakeElement)} />}
        {title}
        <button
          className={cx(css.cta)}
          onClick={close}
          aria-label={t(CTA.CLOSE)}>
          <CloseIcon
            className={cx(css.closeIcon, {
              hideOnLargeScreen: withDesktopBack,
            })}
          />
          {withDesktopBack && (
            <ArrowLeftIcon
              className={cx(css.backIcon, css.hideOnSmallScreen)}
            />
          )}
        </button>
      </div>
    </div>
  )
}
